import { As, Box } from "@chakra-ui/react";
import React, { ReactNode } from "react";

export default function HiddenSeoWrapper({ children, as = "p" }: { children: ReactNode; as?: As }) {
  return (
    <Box
      as={as}
      position="absolute"
      left={-10}
      inlineSize="1px"
      margin="-1px"
      overflow="hidden"
      height={0}
    >
      {children}
    </Box>
  );
}
